var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanmearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209.574,
    height: 201.558,
    viewBox: "0 0 209.574 201.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Scan_me_arrow",
    x: 0,
    y: 0,
    width: 209.574,
    height: 201.558,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Scan_me_arrow-2",
    x: 0,
    y: 0,
    width: 209.574,
    height: 201.558,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scan_me_arrow-3",
    "data-name": "Scan me arrow",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Scan_me_arrow)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Scan_me_arrow-4",
    "data-name": "Scan me arrow",
    d: "M131.371,126.83c-14.951,23.155-41,27.857-61.372,16.681C47.6,131.22,32.513,102.489,25.808,71.966c-3.525-16.052-4.878-32.7-5.287-49.377q1.8,4.02,3.606,8.04c1.72,3.837,3.357,7.773,5.172,11.532,1.879,3.891,3.986,7.617,5.974,11.41,2.24,4.273,7.108.6,5.279-4.116-1.587-4.1-3.077-8.317-4.783-12.337-1.65-3.892-3.5-7.656-5.248-11.473Q25.19,13.986,19.855,2.328C18.091-1.53,14.4-.206,13.251,3.479,7.51,21.837,3.383,41.233.069,60.6c-.655,3.828,3.579,5.41,4.421,1.625C6.8,51.878,9.463,41.738,12.355,31.707,13.193,63,19.8,94.452,34.239,119.291c7.726,13.292,17.621,24.667,29.107,31.788,11.632,7.212,24.3,9.943,37,7.225,13.447-2.878,26.4-11.949,34.811-26.43a4.623,4.623,0,0,0,0-5.045A2.251,2.251,0,0,0,131.371,126.83Z",
    transform: "translate(1.5 116.99) rotate(-59)",
    fill: "#56aa1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Scan_me_arrow-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Scan_me_arrow-5",
    "data-name": "Scan me arrow",
    d: "M131.371,126.83c-14.951,23.155-41,27.857-61.372,16.681C47.6,131.22,32.513,102.489,25.808,71.966c-3.525-16.052-4.878-32.7-5.287-49.377q1.8,4.02,3.606,8.04c1.72,3.837,3.357,7.773,5.172,11.532,1.879,3.891,3.986,7.617,5.974,11.41,2.24,4.273,7.108.6,5.279-4.116-1.587-4.1-3.077-8.317-4.783-12.337-1.65-3.892-3.5-7.656-5.248-11.473Q25.19,13.986,19.855,2.328C18.091-1.53,14.4-.206,13.251,3.479,7.51,21.837,3.383,41.233.069,60.6c-.655,3.828,3.579,5.41,4.421,1.625C6.8,51.878,9.463,41.738,12.355,31.707,13.193,63,19.8,94.452,34.239,119.291c7.726,13.292,17.621,24.667,29.107,31.788,11.632,7.212,24.3,9.943,37,7.225,13.447-2.878,26.4-11.949,34.811-26.43a4.623,4.623,0,0,0,0-5.045A2.251,2.251,0,0,0,131.371,126.83Z",
    transform: "translate(1.5 116.99) rotate(-59)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanmearrow);
export default __webpack_public_path__ + "static/media/Scan me arrow.ed4ff6ebfc1eecbe61d31d91ddccd027.svg";
export { ForwardRef as ReactComponent };